var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfferFuel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Product_Fuel_Solid-Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.33,
    height: 34.137,
    viewBox: "0 0 30.33 34.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5627",
    "data-name": "Path 5627",
    d: "M60.066,20.9v4.277a.7.7,0,0,1-.695.695H57.695A.7.7,0,0,1,57,25.182V20.9a.7.7,0,0,1,.695-.695h1.676A.7.7,0,0,1,60.066,20.9Z",
    transform: "translate(-30.119 -14.656)",
    fill: "#ed8b00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5628",
    "data-name": "Path 5628",
    d: "M30.193,12.271V43.342H10.44V12.271A2.161,2.161,0,0,1,12.6,10.11H28.037a2.156,2.156,0,0,1,2.156,2.161ZM26.847,22.286V15.163a.966.966,0,0,0-.966-.966H14.814a.966.966,0,0,0-.966.966v7.123a.966.966,0,0,0,.966.966H25.881A.966.966,0,0,0,26.847,22.286Z",
    transform: "translate(-7.349 -9.717)",
    fill: "#ed8b00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5629",
    "data-name": "Path 5629",
    d: "M29.938,75.172H4.9a.511.511,0,0,1,0-1.022H29.938a.511.511,0,0,1,0,1.022Z",
    transform: "translate(-4.39 -41.035)",
    fill: "#ed8b00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5630",
    "data-name": "Path 5630",
    d: "M29.827,43.349a.383.383,0,0,1-.383-.383V11.895a1.778,1.778,0,0,0-1.773-1.778H12.235a1.778,1.778,0,0,0-1.778,1.778V42.966a.383.383,0,0,1-.766,0V11.895A2.555,2.555,0,0,1,12.245,9.34H27.67a2.555,2.555,0,0,1,2.555,2.555V42.966a.388.388,0,0,1-.4.383Z",
    transform: "translate(-6.982 -9.34)",
    fill: "#ed8b00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5631",
    "data-name": "Path 5631",
    d: "M53.11,48.324a1.982,1.982,0,0,1-1.982-1.982V35.4a.9.9,0,0,0-.9-.9H49.2a.511.511,0,1,1,0-1.022h1.022A1.926,1.926,0,0,1,52.149,35.4V46.341a.961.961,0,0,0,.961.961.94.94,0,0,0,.68-.281.955.955,0,0,0,.281-.68V31.631a.511.511,0,0,1,1.022,0v14.71a1.972,1.972,0,0,1-1.982,1.982Z",
    transform: "translate(-26.055 -19.991)",
    fill: "#ed8b00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5632",
    "data-name": "Path 5632",
    d: "M59,25.893H57.328a1.083,1.083,0,0,1-1.078-1.078V20.538a1.083,1.083,0,0,1,1.078-1.078H59a1.083,1.083,0,0,1,1.078,1.078v4.277A1.083,1.083,0,0,1,59,25.893Zm-1.676-5.646a.312.312,0,0,0-.312.312v4.277a.312.312,0,0,0,.312.312H59a.312.312,0,0,0,.312-.312v-4.3A.312.312,0,0,0,59,20.226Z",
    transform: "translate(-29.752 -14.289)",
    fill: "#ed8b00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5633",
    "data-name": "Path 5633",
    d: "M57.621,17.237h-.056a.511.511,0,0,1-.455-.567,2.637,2.637,0,0,0-1.6-2.58.511.511,0,1,1,.3-.976,3.677,3.677,0,0,1,2.315,3.669A.511.511,0,0,1,57.621,17.237Z",
    transform: "translate(-29.207 -11.172)",
    fill: "#ed8b00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferFuel);
export default __webpack_public_path__ + "static/media/offer_fuel.05258a165144d0d3b8ce1e061dce8ef4.svg";
export { ForwardRef as ReactComponent };